import { render, staticRenderFns } from "./AddressSummary.vue?vue&type=template&id=5c47c482&scoped=true&"
import script from "./AddressSummary.vue?vue&type=script&lang=js&"
export * from "./AddressSummary.vue?vue&type=script&lang=js&"
import style0 from "./AddressSummary.vue?vue&type=style&index=0&id=5c47c482&prod&scoped=true&lang=css&"
import style1 from "./AddressSummary.vue?vue&type=style&index=1&id=5c47c482&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c47c482",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VChip,VCol,VContainer,VDataTable,VDivider,VExpandTransition,VIcon,VRow,VSkeletonLoader,VSpacer,VTextarea,VTooltip})
